import React from 'react'
import { FaChevronLeft } from 'react-icons/fa'
import { Icon, Flex, VStack, HStack, Button, Heading } from '@chakra-ui/react'

export const PageHeader = ({ heading, onBack, actions = [], children, ...props }) => (
  <VStack align='left' spacing={3} mb={3} {...props}>
    {onBack && (
      <Flex>
        <Button leftIcon={<Icon as={FaChevronLeft} />} onClick={onBack}>
          Voltar
        </Button>
        {/* <Flex flex={1} justify='right'> */}
        {/*    */}
        {/* </Flex> */}
      </Flex>
    )}
    <HStack>
      {heading && (
        <Heading size='xl' flex={1}>
          {heading}
        </Heading>
      )}
      {actions.map(({ label, ...props }, index) => (
        <Button {...props} key={index}>
          {label}
        </Button>
      ))}
      {children}
    </HStack>
  </VStack>
)

export default PageHeader
